import logo from "./logo.svg";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";

import { ToastProvider } from "react-toast-notifications";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import axios from "axios";

import React, { useState, useEffect } from "react";

import { firebaseConfig, api } from "./config";
import { GlobalContext } from "./contexts";

import Login from "./pages/Login";
import Register from "./pages/Register";
import PasswordReset from "./pages/PasswordReset";
import Account from "./pages/Account";
import Loading from "./Loading";
import Layout from "./Layout";
import Payment from "./pages/Payment";

initializeApp(firebaseConfig);

function App() {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  getAuth().onAuthStateChanged(setUser);
  getAuth().onAuthStateChanged(() => setLoading(false));

  const refetchUserData = () => {
    
    if (!user) setUserData(null);
    try {
      user.getIdToken(true).then((token) =>
        axios.get(api + "get_user_data?token=" + token).then(({ data }) => {
          console.log("userData",data)
          setUserData(data);
        })
      );
    } catch {}
    
  };
  useEffect(refetchUserData, [user]);

  let routes = null;
  if (loading) {
    routes = <Route path="*" element={<Loading />}></Route>;
  } else {
    if (!user)
      routes = (
        <React.Fragment>
          <Route path="*" element={<Login />}></Route>
          <Route path="register" element={<Register />}></Route>
          <Route path="password-reset" element={<PasswordReset />}></Route>
        </React.Fragment>
      );
    else routes = <Route path="*" element={<Account />}></Route>;
  }

  return (
    <Layout>
      <Router>
        <GlobalContext.Provider value={{ user, userData, loading, setLoading }}>
          <ToastProvider
            autoDismiss
            autoDismissTimeout={1000}
            placement="bottom-center"
          >
            <Routes>
              {routes}
              <Route path="/checkout" element={<Payment />}></Route>
            </Routes>
          </ToastProvider>
        </GlobalContext.Provider>
      </Router>
    </Layout>
  );
}

export default App;
